/** 
 * @type {import("./defs").StorePlanClusterWeight} 
 */
const store = {
}
/** 
* @returns {import("./defs").StorePlanClusterWeight} 
*/
export default function () {
    return JSON.parse(JSON.stringify(store));
}


// WEBPACK FOOTER //
// ./resources/js/storers/StorePlanClusterWeight.js